import * as Recharts from 'recharts';
import { config } from '@facet-wealth/design';
import './FacetDesignConfigurationBase';

config.setRecharts(Recharts);
